import { render, staticRenderFns } from "./players.vue?vue&type=template&id=486438b8&scoped=true"
import script from "./players.vue?vue&type=script&lang=js"
export * from "./players.vue?vue&type=script&lang=js"
import style0 from "./players.vue?vue&type=style&index=0&id=486438b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486438b8",
  null
  
)

export default component.exports